@if (enabled) {
  <ng-content></ng-content>
}

@if (!enabled) {
  <rt-sidebar-item
    type="heading"
    [name]="name"
    [icon]="icon"
    [href]="href"
    [rightSlot]="rightIcon"
    [attr.margin-bottom-small-x]="addMargin"
  ></rt-sidebar-item>
}

<ng-template #rightIcon>
  <rt-icon name="upgrade" colorToken="colorIconScaleDefault"></rt-icon>
</ng-template>
